import React, {Fragment} from 'react';
import {useTranslation} from "react-i18next";
import Button from "./Button";

function ConfirmationDialog({
                                onConfirm,
                                onCancel,
                                confirmButtonText,
                                cancelButtonText,
                                message,
                                additionalInfo
                            }) {
    const {t} = useTranslation();

        return (
            <>
            <h5 className="title is-5 has-text-weight-bold">{t(message)}</h5>
                {additionalInfo && <p className="subtitle is-6">{t(additionalInfo)}</p>}
                <div className="pt-4">
                    <Button
                        isSubmit={false}
                        isLight={true}
                        className={"has-text-black"}
                        disabled={false}
                        label={t(cancelButtonText) ?? t("dialog.no")}
                        onClick={onCancel}
                    />
                    <Button
                        isSubmit={false}
                        color={"primary"}
                        disabled={false}
                        label={t(confirmButtonText) ?? t("dialog.yes")}
                        onClick={onConfirm}
                    />
                </div>
            </>
        );
}

export default ConfirmationDialog;
